
import { get, call } from 'vuex-pathify'

export default {
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'vs-button'
    },
    variantId: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    items: get('productCompare/items'),
    inList() {
      return this.items.includes(this.variantId)
    },
    icon() {
      return this.inList ? 'trash-alt' : 'sliders-v-alt'
    },
    label() {
      return this.inList
        ? this.$t('eshop.compare.remove')
        : this.$t('eshop.compare.add')
    }
  },
  methods: {
    addItem: call('productCompare/addItem'),
    removeItem: call('productCompare/removeItem'),
    onClick() {
      const event = this.inList ? 'remove' : 'add'

      if (this.inList) {
        this.removeItem(this.variantId)
      } else {
        this.addItem(this.variantId)
      }

      this.$emit(event)
    }
  }
}
